import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * IFS Shipping Hub - Full-featured IFS Inforsure FedEx API management
 * Uses TabHub component pattern for consistent admin styling
 */
import { useState, useEffect } from 'react';
import { FaGlobeAmericas, FaAddressBook, FaTools, FaCalculator, FaTruck, FaPassport } from 'react-icons/fa';
import { TabHub } from '../../../components/Hubs/TabHub';
import { ifsService } from '../../../services/ifsService';
import styled from 'styled-components';
import ReferenceDataTab from './ReferenceDataTab';
import AddressBookTab from './AddressBookTab';
import ShippingToolsTab from './ShippingToolsTab';
import CostCalculatorTab from './CostCalculatorTab';
import ShipmentTrackerTab from './ShipmentTrackerTab';
import InternationalTab from './InternationalTab';
const ConnectionDot = styled.span `
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${p => p.$connected ? '#00c853' : '#ff1744'};
  margin-left: 8px;
  box-shadow: 0 0 6px ${p => p.$connected ? 'rgba(0, 200, 83, 0.5)' : 'rgba(255, 23, 68, 0.5)'};
`;
const ConnectionStatus = styled.div `
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-secondary);
  padding: 6px 14px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
`;
const IFSShippingHub = () => {
    const [activeTab, setActiveTab] = useState('reference');
    const [isConnected, setIsConnected] = useState(null);
    useEffect(() => {
        // Quick connection test on mount
        ifsService.getCountryState().then(res => {
            const connected = res.ok && res.data?.success && (res.data?.data?.status === '1' || res.data?.data?.status === 1);
            setIsConnected(connected ?? false);
        }).catch(() => setIsConnected(false));
    }, []);
    const tabs = [
        {
            id: 'reference',
            label: 'Reference Data',
            description: 'Countries & Types',
            icon: _jsx(FaGlobeAmericas, {}),
            component: _jsx(ReferenceDataTab, {}),
        },
        {
            id: 'addresses',
            label: 'Address Book',
            description: 'Senders & Recipients',
            icon: _jsx(FaAddressBook, {}),
            component: _jsx(AddressBookTab, {}),
        },
        {
            id: 'tools',
            label: 'Shipping Tools',
            description: 'Checks & Validation',
            icon: _jsx(FaTools, {}),
            component: _jsx(ShippingToolsTab, {}),
        },
        {
            id: 'cost',
            label: 'Cost Calculator',
            description: 'Zones & Pricing',
            icon: _jsx(FaCalculator, {}),
            component: _jsx(CostCalculatorTab, {}),
        },
        {
            id: 'tracking',
            label: 'Shipment Tracker',
            description: 'Track & Map',
            icon: _jsx(FaTruck, {}),
            component: _jsx(ShipmentTrackerTab, {}),
        },
        {
            id: 'international',
            label: 'International',
            description: 'AES & Customs',
            icon: _jsx(FaPassport, {}),
            component: _jsx(InternationalTab, {}),
        },
    ];
    const headerActions = (_jsxs(ConnectionStatus, { children: ["IFS API", _jsx(ConnectionDot, { "$connected": isConnected === true }), isConnected === null ? 'Checking...' : isConnected ? 'Connected' : 'Disconnected'] }));
    return (_jsx(TabHub, { title: "IFS Advanced Tools", subtitle: "Advanced IFS Inforsure API tools \u2014 reference data, address book, cost calculation, tracking & international tools", activeTab: activeTab, tabs: tabs, onTabChange: (id) => setActiveTab(id), headerActions: headerActions }));
};
export default IFSShippingHub;
